module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword#toc_marker-2"
    }
  }, [_vm._v("Foreword by Dave Ferguson")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#toc_marker-3"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1"
    }
  }, [_vm._v("1 Someone Is Waiting for You")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2"
    }
  }, [_vm._v("2 Is It Worth It?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Evangelism Is Awkward")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 They’re Experience Based")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 You Are in a Spiritual Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Engaging the Spiritual Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 How to Hear God’s Voice in Witness")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/interlude",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interlude: A Powerful Official")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 God’s Role")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Your Role")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Don’t Miss the Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 How Do I Avoid Being Pushy?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 How to Turn the Conversation to Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Don’t Keep Them Waiting")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendix1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Five Guidelines for Hearing God")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendix2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: GIG Suggestions by Theme")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendix3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3: Conversation Starters")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendix4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 4: Writing Your Lordship/Transformational Story")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise_for",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Beyond Awkward")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/about_author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/beyondawkward_videocampaign",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beyond Awkward Video Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/forge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forge")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/more_ivp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0